import { labelWeight } from '@hex/calculators-shared/types/affordability';
import { Flex, tokens, Typography, HelpButton } from '@sapphire-react/core';
import { ReactNode } from 'react';

export type ChartItem = {
  value?: string;
  color?: string;
  legendTitle: string;
  legendSubtitle?: string;
  contextualHelpContent?: ReactNode;
  testId?: string;
  borderRadius?: string | number;
  displayLabel?: string;
  labelWeight?: labelWeight;
};
type Props = {
  chartItem: ChartItem;
};

export function Footer({ chartItem }: Props) {
  const { value, legendTitle, legendSubtitle, contextualHelpContent, testId } = chartItem;

  return (
    <Flex paddingTop={tokens.size.spacing3xs} paddingBottom={tokens.size.spacing3xs}>
      <Flex flexDirection={'column'} width={'100%'}>
        <Flex justifyContent={'space-between'}>
          <Flex alignItems={'center'}>
            <Typography.Body
              marginRight={tokens.size.spacing3xs}
              size={'sm'}
            >
              {legendTitle}
            </Typography.Body>
            {contextualHelpContent && (
              <HelpButton variant={'help'} aria-label={'Hjälp!'} contentBody={contextualHelpContent} />
            )}
          </Flex>
          <Flex alignItems={'center'}>
            <Typography.Body size={'sm'} data-test-id={testId}>
              {value}
            </Typography.Body>
          </Flex>
        </Flex>
        <Typography.Body
          size={'xs'}
          data-test-id={`${testId}-perc`}
          UNSAFE_style={{
            color: tokens.color.foregroundOnNegative.value,
          }}
        >
          {legendSubtitle}
        </Typography.Body>
      </Flex>
    </Flex>
  );
}
